import {
  Gender,
  MonthlyBudgetResetType,
  PositionInFacility,
  ResidentListSort,
  UserRole,
} from '../../core/types/enums';
import { SelectOptions } from '../../core/types/types';
import { departmentIcons } from './departmentIcons';

export const genderOptions: SelectOptions<Gender> = [
  { value: Gender.Male, label: 'Herr' },
  { value: Gender.Female, label: 'Frau' },
  { value: Gender.Unisex, label: 'Unisex' },
  { value: Gender.None, label: '-' },
];

export const iconOptions: SelectOptions<string> = departmentIcons.map(icon => ({
  icon: icon.url,
  value: icon.url,
}));

export const positionOptions: SelectOptions<PositionInFacility> = [
  {
    value: PositionInFacility.FacilityManagement,
    label: 'Einrichtungsleitung',
  },
  { value: PositionInFacility.Administration, label: 'Verwaltung' },
  {
    value: PositionInFacility.Housekeeping,
    label: 'Leitung SD/ Hauswirtschaft',
  },
  {
    value: PositionInFacility.SocialService,
    label: 'sozialer Dienst/ Ergo/ Pflege',
  },
  { value: PositionInFacility.NursingManagement, label: 'Pflegedienstleitung' },
  {
    value: PositionInFacility.ResidientialManagement,
    label: 'Wohnbereichsleitung',
  },
  { value: PositionInFacility.Reception, label: 'Rezeption/ Haus' },
  { value: PositionInFacility.RegionalManagement, label: 'Regionalleitung' },
  { value: PositionInFacility.QualityManagement, label: 'Qualitätsmanagement' },
  { value: PositionInFacility.Open, label: 'offen' },
];

export const roleOptions: SelectOptions<UserRole> = [
  { value: UserRole.Admin, label: 'Administrator:in' },
  { value: UserRole.Manager, label: 'Manager' },
  { value: UserRole.User, label: 'Sammler mit WB' },
  { value: UserRole.UserCollectorWithoutWB, label: 'Sammler ohne WB' },
  { value: UserRole.UserOrdererWithoutWB, label: 'Besteller ohne WB' },
];

export const RELEVANCE_SORT_ID = 6;

export const sortOptions: SelectOptions<number> = [
  { value: 0, label: 'Produktsortiment' },
  { value: 1, label: 'Produkt-Nr.' },
  { value: 2, label: 'Bestseller' },
  { value: 3, label: 'Neue Produkte' },
  { value: 4, label: 'A-Z' },
  { value: 5, label: 'Preis' },
];

export const searchSortOptions: SelectOptions<number> = [
  { value: RELEVANCE_SORT_ID, label: 'Relevanz' },
  ...sortOptions,
];

export const monthlyBudgetResetTypeOptions: SelectOptions<MonthlyBudgetResetType> =
  [
    {
      value: MonthlyBudgetResetType.BeginningOfMonth,
      label: '1. Tag des Monats',
    },
    {
      value: MonthlyBudgetResetType.MiddleOfMonth,
      label: '15. Tag des Monats',
    },
  ];

export const residentListSortOptions: SelectOptions<string> = [
  { value: ResidentListSort.lastName, label: 'Nachname (aufsteigend)' },
  { value: ResidentListSort.firstName, label: 'Vorname (aufsteigend)' },
  { value: ResidentListSort.roomNumber, label: 'Zimmernummer (aufsteigend)' },
];
